<template>
  <div class="login-page">
    <!-- Animated background orbs -->
    <div class="orb orb-1"></div>
    <div class="orb orb-2"></div>
    <div class="orb orb-3"></div>

    <!-- Floating particles -->
    <div
      v-for="i in 12"
      :key="i"
      class="particle"
      :style="particleStyle(i)"
    ></div>

    <!-- Login card -->
    <div class="login-card">
      <!-- Logo -->
      <div class="logo-wrap">
        <div class="logo-glow"></div>
        <img src="/fav.jpg" alt="AL-Mandalawi" class="login-logo" />
      </div>

      <h1 class="login-title">مرحباً بك</h1>
      <p class="login-sub">سجّل دخولك للمتابعة</p>

      <form @submit.prevent="post()">
        <!-- Username -->
        <div class="field-wrap">
          <div class="field-icon">
            <i class="fas fa-user"></i>
          </div>
          <input
            type="text"
            v-model="postData.email"
            placeholder="اسم المستخدم"
            class="field-input"
            autocomplete="username"
          />
          <span class="field-line"></span>
        </div>

        <!-- Password -->
        <div class="field-wrap">
          <div class="field-icon">
            <i class="fas fa-lock"></i>
          </div>
          <input
            :type="showPassword ? 'text' : 'password'"
            v-model="postData.password"
            placeholder="كلمة المرور"
            class="field-input"
            autocomplete="current-password"
          />
          <button
            type="button"
            class="eye-btn"
            @click="showPassword = !showPassword"
          >
            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
          <span class="field-line"></span>
        </div>

        <!-- Submit -->
        <button
          type="submit"
          class="login-btn"
          :class="{ loading: postLoader }"
          :disabled="postLoader"
        >
          <span v-if="!postLoader">
            <i class="fas fa-sign-in-alt ml-2"></i>
            تسجيل الدخول
          </span>
          <span v-else class="spinner-wrap">
            <span class="btn-spinner"></span>
            جاري الدخول...
          </span>
        </button>
      </form>

      <p class="brand-tag">AL-Mandalawi &copy; {{ new Date().getFullYear() }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPassword: false,
      postData: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    post() {
      this.login(this.postData).then(() => {
        if (this.postData.email === "muser") {
          this.$router.push("/maintenance_orders");
        } else {
          this.$router.push("/orders");
        }
      });
    },
    particleStyle(index) {
      const seed = index * 137.508;
      const x = ((seed * 9301 + 49297) % 233280) / 233280;
      const y = ((seed * 6871 + 13901) % 194443) / 194443;
      const size = 3 + (index % 5) * 2;
      const delay = (index * 0.4) % 6;
      const duration = 6 + (index % 4) * 2;
      return {
        left: `${x * 100}%`,
        top: `${y * 100}%`,
        width: `${size}px`,
        height: `${size}px`,
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
      };
    },
  },
  mounted() {
    if (localStorage.getItem("car_user_Info") !== null) {
      this.$router.push("/orders");
    }
  },
};
</script>

<style scoped>
/* ── Page ───────────────────────────────── */
.login-page {
  min-height: 100vh;
  background: #0f172a;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  direction: rtl;
}

/* ── Background orbs ────────────────────── */
.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.35;
  animation: orbFloat 10s ease-in-out infinite;
}
.orb-1 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, #10b981, transparent 70%);
  top: -180px;
  right: -120px;
  animation-delay: 0s;
}
.orb-2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #0ea5e9, transparent 70%);
  bottom: -150px;
  left: -100px;
  animation-delay: 3s;
}
.orb-3 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, #6366f1, transparent 70%);
  top: 40%;
  left: 30%;
  animation-delay: 6s;
}
@keyframes orbFloat {
  0%, 100% { transform: translateY(0) scale(1); }
  50%       { transform: translateY(-30px) scale(1.05); }
}

/* ── Particles ──────────────────────────── */
.particle {
  position: absolute;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.5);
  animation: particleDrift linear infinite;
  pointer-events: none;
}
@keyframes particleDrift {
  0%   { transform: translateY(0) scale(1);   opacity: 0.6; }
  50%  { transform: translateY(-40px) scale(1.3); opacity: 1; }
  100% { transform: translateY(0) scale(1);   opacity: 0.6; }
}

/* ── Card ───────────────────────────────── */
.login-card {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 400px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 40px 36px 32px;
  backdrop-filter: blur(20px);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5);
  animation: cardIn 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@keyframes cardIn {
  from { opacity: 0; transform: translateY(40px) scale(0.95); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* ── Logo ───────────────────────────────── */
.logo-wrap {
  position: relative;
  width: 90px;
  height: 90px;
  margin: 0 auto 20px;
}
.login-logo {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  position: relative;
  z-index: 2;
  border: 3px solid rgba(16, 185, 129, 0.6);
}
.logo-glow {
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  background: conic-gradient(#10b981, #059669, #0ea5e9, #10b981);
  animation: logoSpin 4s linear infinite;
  z-index: 1;
  filter: blur(3px);
}
@keyframes logoSpin {
  to { transform: rotate(360deg); }
}

/* ── Headings ───────────────────────────── */
.login-title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
  animation: slideUp 0.6s 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.login-sub {
  text-align: center;
  font-size: 0.85rem;
  color: rgba(255,255,255,0.45);
  margin-bottom: 28px;
  animation: slideUp 0.6s 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
}
@keyframes slideUp {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Fields ─────────────────────────────── */
.field-wrap {
  position: relative;
  margin-bottom: 22px;
  animation: fieldIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.field-wrap:nth-child(1) { animation-delay: 0.35s; }
.field-wrap:nth-child(2) { animation-delay: 0.45s; }
@keyframes fieldIn {
  from { opacity: 0; transform: translateX(20px); }
  to   { opacity: 1; transform: translateX(0); }
}

.field-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255,255,255,0.35);
  font-size: 0.9rem;
  transition: color 0.3s;
}
.field-wrap:focus-within .field-icon {
  color: #10b981;
}

.field-input {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 0.95rem;
  padding: 10px 28px 10px 32px;
  direction: rtl;
}
.field-input::placeholder {
  color: rgba(255,255,255,0.3);
}

.field-line {
  display: block;
  height: 1px;
  background: rgba(255,255,255,0.12);
  transition: background 0.3s, transform 0.3s;
  transform-origin: right;
}
.field-wrap:focus-within .field-line {
  background: #10b981;
  box-shadow: 0 0 8px rgba(16,185,129,0.4);
}

.eye-btn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: rgba(255,255,255,0.35);
  cursor: pointer;
  padding: 4px;
  transition: color 0.3s;
}
.eye-btn:hover { color: #10b981; }

/* ── Button ─────────────────────────────── */
.login-btn {
  width: 100%;
  margin-top: 8px;
  padding: 13px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.25s, box-shadow 0.25s, opacity 0.25s;
  box-shadow: 0 8px 24px rgba(16,185,129,0.35);
  animation: fieldIn 0.5s 0.55s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 14px 32px rgba(16,185,129,0.45);
}
.login-btn:active:not(:disabled) {
  transform: scale(0.98);
}
.login-btn.loading, .login-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.spinner-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── Footer ─────────────────────────────── */
.brand-tag {
  text-align: center;
  font-size: 0.75rem;
  color: rgba(255,255,255,0.25);
  margin-top: 24px;
  letter-spacing: 0.05em;
}
</style>
